import React, { useEffect, useState } from "react";
import styles from "../../../styles/scope1/dashboard.module.css";
import { durationObj, monthSort } from "../../../utils/constant";
import LineChart from "../../../Components/GraphNCharts/LineChart";
import PieChart from "../../../Components/GraphNCharts/Pie";
import { Box, Typography } from "@mui/material";
import BarChart from "../../../Components/GraphNCharts/BarChart";
import GlobalChart from "../../../Components/GraphNCharts/GlobalChart";
import TableChart from "../../../Components/GraphNCharts/TableChart";
import EchartDoughnutChart from "../../../Components/GraphNCharts/EchartDoughnut";
import { get } from "../../../utils/api";
import CircleIcon from "@mui/icons-material/Circle";
import PeriodFilter from "../../../Components/Common/PeriodFilter";
import { fixedTons, formatNumberCommaSeparated } from "../../../utils/common";
 import useAuthStore from "../../../store/ContextUser";
const Dashboard = () => {
  const currentDate = new Date();
  const {selectedCompany}= useAuthStore();
  const currentYear = currentDate.getFullYear();
  const [month, setMonth] = useState("1M");
  const [tableData, setTableData] = useState();
  const [ghg, setGhg] = useState([]);
  const [emissionVehicleType, setEmissionVehicleType] = useState([]);
  const [stationaryEmission, setStationaryEmission] = useState([]);
  const [mobileEmissionTotal, setMobileEmissionTotal] = useState([]);
  const [mobileEmission, setMobileEmission] = useState([]);
  const [vehicleEmission, setVehicleEmission] = useState([]);
  const [fugitive, setFugitive] = useState([]);
  const [stationaryCombustion, setStationaryCombustion] = useState({});
  const [mobileCombustion, setMobileCombustion] = useState({});
  const [fugitiveCombustion, setFugitiveCombustion] = useState({});
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });
  const [selectedFacility, setSelectedFacility] = useState([]);

  useEffect(() => {
    fetchStationaryEmission();
    fetchMobileEmissionTotal();
    fetchMobileEmission();
    fetchEmissionByVehicle();
    fetchVehicleEmission();
    fetchFugitiveEmission();
    fetchStationary();
    fetchMobile();
    fetchFugitive();
    fetchGHGEmission();
  }, [fromDate, toDate, selectedFacility,selectedCompany]);

  const fetchGlobalData = async () => {
    try {
      let response = await get(
        `dashboard/globalEmission/scope1/totalEmission?timeFrame=${month}&companyId=${selectedCompany?._id}`
      );
      setTableData(response?.data?.data);
      console.log("first45", response?.data?.data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchGlobalData();
  }, [month,selectedCompany]);

  // useEffect(() => {
  //   const currentDate = new Date();
  //   setMonth(String(currentDate.getMonth() + 1).padStart(2, "0"));
  //   setYear(currentDate.getFullYear());
  // }, []);

  const fetchGHGEmission = async () => {
    const res = await get(
      `/dashboard/scope1/emissionAnalysis?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );
 

    setGhg([
      {
        total: res?.data?.total?.toFixed(3),
        labels: res?.data?.finalData?.[0]?.data?.map(
          (el) => monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
        ),
        dataSet:
          res?.data?.finalData
            ?.map((el) =>
              el?.data?.map((el) => el?.totalEmission)?.filter(Boolean)
            )
            ?.filter((res) => res?.length > 0)?.length > 0
            ? res?.data?.finalData?.map((el, i) => ({
                label: el?.label,
                data: el?.data?.map((el) => fixedTons(el?.totalEmission)) || 0,
                borderColor: colors[i],
                backgroundColor: colors[i],
                tension: 0.4,
                fill: true,
                pointRadius: 0,
              }))
            : [],
      },
    ]);
  };

  const fetchStationaryEmission = async () => {
    const res = await get(
      `/dashboard/scope1/statinaryEmissionAnalysis?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );
    setStationaryEmission(res?.data);
  };

  const fetchMobileEmissionTotal = async () => {
    const res = await get(
      `/dashboard/scope1/mobileEmissionAnalysisTotal?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );
    setMobileEmissionTotal(res?.data);
  };

  const fetchMobileEmission = async () => {
    const res = await get(
      `/dashboard/scope1/mobileEmissionAnalysisOffRoad?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );
    setMobileEmission(res?.data);
  };

  const fetchEmissionByVehicle = async () => {
    const res = await get(
      `/dashboard/scope1/onRoadEmissionByTransportType?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );
    setEmissionVehicleType([
      {
        labels: res?.data?.data?.map((el) => el?.transportType),
        dataSet: [
          {
            label: "GHG Emissions (tCO2e)",
            data: res?.data?.data?.map((el) => el?.totalEmission),
            borderColor: "#0051B7",
            backgroundColor: "#0051B7",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
        ],
      },
    ]);
  };

  const fetchVehicleEmission = async () => {
    const res = await get(
      `/dashboard/scope1/onRoadEmissionByVehicle?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );
    setVehicleEmission([
      {
        color: "#FF4444",
        label: "Company Owned",
        value:
          res?.data?.data
            ?.find((el) => el?.ownershipType === "Company Owned")
            ?.totalEmissionsByOwnership?.toFixed(3) || 0,
      },
      {
        color: "#0066E7",
        label: "Third Party Vehicles",
        value:
          res?.data?.data
            ?.find((el) => el?.ownershipType === "Leased")
            ?.totalEmissionsByOwnership?.toFixed(3) || 0,
      },
    ]);
  };

  const fetchFugitiveEmission = async () => {
    const res = await get(
      `/dashboard/scope1/fugitiveEmissionAnalysis?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );
    setFugitive([
      {
        value: parseFloat(res?.data?.refrigerationSum) || 0,
        title: "Total Quantity of Refrigerants Used (Kg) :",
        labels: res?.data?.refrigeration?.map((el) => el?.typeOfSubstance),
        dataSet: [
          {
            label: "Quantity",
            data: res?.data?.refrigeration?.map(
              (el) => el?.totalQuantityReleased
            ),
            borderColor: "#0051B7",
            backgroundColor: "#0051B7",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
        ],
      },
      {
        value: parseFloat(res?.data?.fireSum) || 0,
        labels: res?.data?.fireExtinguisher?.map((el) => el?.typeOfSubstance),
        title: "Total Quantity of Fire Extinguisher Used (Kg) :",
        dataSet: [
          {
            label: "Quantity",
            data: res?.data?.fireExtinguisher?.map(
              (el) => el?.totalQuantityReleased
            ),
            borderColor: "#0051B7",
            backgroundColor: "#0051B7",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
        ],
      },
    ]);
  };

  const fetchStationary = async () => {
    const res = await get(
      `/dashboard/scope1/stationaryCombusionEmissionLineChart?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );
    setStationaryCombustion({
      labels: res?.data?.data?.[0]?.data?.map(
        (el) => monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
      ),
      dataSet: res?.data?.data?.map((el, i) => ({
        label: el?.facility,
        data: el?.data?.map((e) => e?.totalEmission),
        borderColor: colors[i],
        backgroundColor: colors[i],
        tension: 0.4,
        fill: true,
        pointRadius: 0,
      })),
    });
    console.log(res);
  };

  const fetchMobile = async () => {
    const res = await get(
      `/dashboard/scope1/mobileCombusionEmissionLineChart?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );
    setMobileCombustion({
      labels: res?.data?.data?.[0]?.data?.map(
        (el) => monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
      ),
      dataSet: res?.data?.data?.map((el, i) => ({
        label: el?.facility,
        data: el?.data?.map((e) => e?.totalEmission),
        borderColor: colors[i],
        backgroundColor: colors[i],
        tension: 0.4,
        fill: true,
        pointRadius: 0,
      })),
    });
    console.log(res);
  };

  const fetchFugitive = async () => {
    const res = await get(
      `/dashboard/scope1/fugitiveEmissionLineChart?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );
    setFugitiveCombustion({
      labels: res?.data?.finalData?.[0]?.data?.map(
        (el) => monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
      ),
      dataSet: res?.data?.finalData?.map((el, i) => ({
        label: el?.facility,
        data: el?.data?.map((e) => e?.totalEmission),
        borderColor: colors[i],
        backgroundColor: colors[i],
        tension: 0.4,
        fill: true,
        pointRadius: 0,
      })),
    });
    console.log(res);
  };

  const generateYearList = (startYear = 2020) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }
    return years;
  };
  const yearList = generateYearList(2020);

  // Stationary Emission
  let stationaryEmissionLabels = [
    stationaryEmission?.naturalGasData?.length > 0
      ? {
          color: "#FFBB33",
          label: "Natural Gas",
          value:
            stationaryEmission?.naturalGasData?.[0]?.emission?.toFixed(3) || 0,
        }
      : "",
    stationaryEmission?.coalData?.length > 0
      ? {
          color: "#000000",
          label: "Coal",
          value: stationaryEmission?.coalData?.[0]?.emission?.toFixed(3) || 0,
        }
      : "",
    stationaryEmission?.petrolData?.length > 0
      ? {
          color: "#0066E7",
          label: "Petrol",
          value: stationaryEmission?.petrolData?.[0]?.emission?.toFixed(3) || 0,
        }
      : "",
    stationaryEmission?.dieselData?.length > 0
      ? {
          color: "#FF4444",
          label: "Diesel",
          value: stationaryEmission?.dieselData?.[0]?.emission?.toFixed(3) || 0,
        }
      : "",
    stationaryEmission?.fuelData?.length > 0
      ? {
          color: "#28C76F",
          label: "Fuel Oil",
          value: stationaryEmission?.fuelData?.[0]?.emission?.toFixed(3) || 0,
        }
      : "",
    stationaryEmission?.lpgData?.length > 0
      ? {
          color: "#a16ae8",
          label: "LPG",
          value: stationaryEmission?.lpgData?.[0]?.emission?.toFixed(3) || 0,
        }
      : "",
    stationaryEmission?.propaneData?.length > 0
      ? {
          color: "#ff6b9d",
          label: "Propane",
          value: stationaryEmission?.propaneData?.[0]?.emission?.toFixed(3) || 0,
        }
      : "",
  ].filter(Boolean);

  // mobile combustion Analysis
  const labels = [
    {
      color: "#FFBB33",
      label: "On Road",
      value:
        mobileEmissionTotal?.onRoadData?.[0]?.totalEmission?.toFixed(3) || 0,
    },
    {
      color: "#0066E7",
      label: "Off Road",
      value:
        mobileEmissionTotal?.offRoadData?.[0]?.totalEmission?.toFixed(3) || 0,
    },
  ];
  const mobData = [
    mobileEmissionTotal?.onRoadData?.[0]?.totalEmission,
    mobileEmissionTotal?.offRoadData?.[0]?.totalEmission,
  ].filter(Boolean);

  const mobileEmissionData = [
    {
      data: [
        fixedTons(mobileEmissionTotal?.onRoadData?.[0]?.totalEmission) || 0,
        fixedTons(mobileEmissionTotal?.offRoadData?.[0]?.totalEmission) || 0,
      ],
      backgroundColor: ["#FFBB33", "#0066E7"],
      borderColor: "#fff",
      borderWidth: 0,
      offset: [0, 15],
    },
  ];

  // Mobile Combustion Off Road
  let mobileEmissionOffRoad = [
    {
      title: "Industrial Machinery",
      value:
        mobileEmission?.offRoadData
          ?.find((el) => el?.machineryCategory === "Industrial")
          ?.["totalEmissionSum"]?.toFixed(3) || 0,
      data:
        mobileEmission?.offRoadData
          ?.find((el) => el?.machineryCategory === "Construction")
          ?.totalFuelByCategory?.filter(Boolean)?.length > 0
          ? mobileEmission?.offRoadData
              ?.find((el) => el?.machineryCategory === "Industrial")
              ?.totalFuelByCategory?.map((el, i) => ({
                label: el?.fuelType,
                value: el?.totalEmission?.toFixed(3) || 0,
                unit: el?.unit,
                color:
                  stationaryEmissionLabels?.find(
                    (e) => el?.fuelType?.startsWith(e?.label) && e?.color
                  )?.color || "#a16ae8",
              }))
          : [],
    },
    {
      title: "Construction Machinery",
      value:
        mobileEmission?.offRoadData
          ?.find((el) => el?.machineryCategory === "Construction")
          ?.["totalEmissionSum"]?.toFixed(3) || 0,
      data:
        mobileEmission?.offRoadData
          ?.find((el) => el?.machineryCategory === "Construction")
          ?.totalFuelByCategory?.filter(Boolean)?.length > 0
          ? mobileEmission?.offRoadData
              ?.find((el) => el?.machineryCategory === "Construction")
              ?.totalFuelByCategory?.map((el, i) => ({
                label: el?.fuelType,
                value: el?.totalEmission?.toFixed(3) || 0,
                unit: el?.unit,
                color:
                  stationaryEmissionLabels?.find(
                    (e) => el?.fuelType?.startsWith(e?.label) && e?.color
                  )?.color || "#a16ae8",
              }))
          : [],
    },
  ];

  // vehicle emission
  const vehicleEmissionData =
    vehicleEmission?.map((el) => Number(el?.value)).filter(Boolean)?.length > 0
      ? [
          {
            data: vehicleEmission?.map((el) => Number(el?.value)),
            backgroundColor: ["#FF4444", "#0066E7"],
            borderColor: "#fff",
            borderWidth: 0,
            offset: [0, 15],
          },
        ]
      : [];

  const colors = [
    "rgba(255, 68, 68, 1)",
    "rgba(255, 187, 51, 1)",
    "rgba(0, 102, 231, 1)",
  ];

  const comustionDataset = [
    {
      comustionHeading: "Stationary Combustion emissions:",
      dataset: stationaryCombustion?.dataSet,
      labels: stationaryCombustion?.labels,
    },
    {
      comustionHeading: "Mobile Combustion emissions:",
      dataset: mobileCombustion?.dataSet,
      labels: mobileCombustion?.labels,
    },
    {
      comustionHeading: "Fugitive Combustion emissions:",
      dataset: fugitiveCombustion?.dataSet,
      labels: fugitiveCombustion?.labels,
    },
  ];

  return (
    <div>
      <div className={styles.heading_container}>
        <p className={styles.heading}>Scope 1</p>
        <PeriodFilter
          {...{
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            yearList,
            setSelectedFacility,
            selectedFacility,
          }}
        />
      </div>
      <p className={styles.card_heading}>Emissions Analysis</p>
      <div className={styles.cards}>
        <p className={styles.emission_heading}>
          Total GHG Emissions (tCO2e):{" "}
          <span className={styles.emission_heading_span}>
            {formatNumberCommaSeparated(fixedTons(ghg[0]?.total))}
          </span>
        </p>
        {/* <div className={styles.scopeSection}>
          {ghg[0]?.dataSet?.map((item, index) => (
            <div key={index} className={styles.scopeItem}>
              <div className={styles.scopeContent}>
                <p
                  className={styles.scopeIcon}
                  style={{ backgroundColor: colors[index] }}
                ></p>
                <p className={styles.scopeHeading}>{item.label}</p>
              </div>
            </div>
          ))}
        </div> */}

        <LineChart
          dataset={ghg[0]?.dataSet}
          labels={ghg[0]?.labels}
          yAxisTitle={"GHG Emissions (tCO2e)"}
          display={true}
          year={fromDate?.year}
        />
      </div>

      <p className={styles.card_heading}>Geographical analysis</p>
      <div className={styles.world_map_container}>
        <div className={styles.world_map_heading_container}>
          <p className={styles.emission_heading}>Emisssion By Location</p>
          <div style={{ display: "flex", gap: "12px" }}>
            <select
              name="month"
              id="month"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              className={styles.heading_select_month}
            >
              {durationObj?.map((m) => (
                <option key={m?.id} value={m?.id}>
                  {m?.label}
                </option>
              ))}
            </select>

            {/* <select
              name="year"
              id="year"
              value={year}
              onChange={(e) => setYear(e.target.value)}
              className={styles.heading_select_year}
            >
              {["World"].map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select> */}
          </div>
        </div>
        <div className={styles.world_map_data}>
          <div className={styles.world_map_table}>
            <TableChart tableData={tableData} />
          </div>
          <div className={styles.world_map_chart}>
            <GlobalChart tableData={tableData} />
          </div>
        </div>
      </div>

      {/* Stationary Emission Analysis */}
      <p className={styles.card_heading}>Stationary Emissions Analysis</p>
      <div className={styles.doughnut_container} style={{ padding: "1.5rem" }}>
        <p className={styles.card_subheading}>
          Total Stationary Combustion Emissions (tCO2e):{" "}
          {formatNumberCommaSeparated(
            fixedTons(stationaryEmission?.totalEmission ?? 0)
          )}
        </p>
        {stationaryEmissionLabels?.length > 0 ? (
          <div className={styles.stationary_chart_container}>
            <div className={styles.doughnut_table_div}>
              {stationaryEmissionLabels.map((item, index) => (
                <div key={index} className={styles.table_container}>
                  <div className={styles.table_row}>
                    <span
                      className={styles.table_row_label}
                      style={{
                        backgroundColor: item.color,
                      }}
                    ></span>
                    <span className={styles.table_text}>{item.label}</span>
                  </div>
                  <span className={styles.table_text}>
                    {formatNumberCommaSeparated(fixedTons(item?.value ?? 0))}
                  </span>
                </div>
              ))}
            </div>
            <Box sx={{ width: "45%", ml: 0 }}>
              <EchartDoughnutChart
                labels={stationaryEmissionLabels?.map((el) => el?.label)}
                dataPoints={stationaryEmissionLabels?.map((el) =>
                  Number(el?.value)
                )}
                colors={stationaryEmissionLabels?.map((el) => el?.color)}
                legendPosition="top"
                customWidth={"200px"}
                customHeight={"70%"}
                hide={true}
              />
            </Box>
          </div>
        ) : (
          <Box sx={{ height: "80%" }}>
            <Typography
              sx={{
                textAlign: "center",
                color: "#d3d3d3",
                fontWeight: "bold",
                alignItems: "center",
                fontFamily: "inter",
                my: "8rem",
                fontSize: "24px",
              }}
            >
              No Data Found
            </Typography>
          </Box>
        )}
      </div>
      {/* Mobile Emission Analysis */}
      <p className={styles.card_heading} style={{ marginTop: "1rem" }}>
        Mobile Emissions Analysis:
      </p>
      <div className={styles.mobile_container}>
        <div className={styles.diversity_container}>
          <p className={styles.card_heading}>Total</p>
          <p className={styles.card_subheading}>
            <CircleIcon sx={{ fontSize: "6px", mr: 1 }} />
            Total Mobile Combustion Emissions (tCO2e):{" "}
            {formatNumberCommaSeparated(
              fixedTons(mobileEmissionTotal?.totalEmission) || 0
            )}
          </p>
          {mobData?.length > 0 ? (
            <div>
              <div className={styles.total_combusstion_pie}>
                <PieChart
                  labels={["On Road", "Off Road"]}
                  dataset={mobileEmissionData}
                  customWidth={150}
                  customHeight={150}
                />
              </div>
              <div className={styles.table_div}>
                {labels.map((item, index) => (
                  <div key={index} className={styles.table_container}>
                    <div className={styles.table_row}>
                      <span
                        className={styles.table_row_label}
                        style={{
                          backgroundColor: item.color,
                        }}
                      ></span>
                      <span className={styles.table_text}>{item.label}</span>
                    </div>
                    <span className={styles.table_text}>
                      {formatNumberCommaSeparated(fixedTons(item?.value ?? 0))}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <Box sx={{ height: "80%" }}>
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#d3d3d3",
                  fontWeight: "bold",
                  alignItems: "center",
                  my: "8rem",
                  fontSize: "24px",
                  fontFamily: "inter",
                }}
              >
                No Data Found
              </Typography>
            </Box>
          )}
        </div>
      </div>

      {/* On Road */}
      <div className={styles.cards}>
        <p className={styles.card_heading}>
          <CircleIcon sx={{ fontSize: "8px", mr: 1 }} />
          On-Road:
        </p>
        <p className={styles.card_subheading}>
          <CircleIcon sx={{ fontSize: "6px", mr: 1 }} />
          Emissions by Transport Type (tCO2e)
        </p>
        <div className={styles.onroad_container}>
          <div className={styles.onroad_emission}>
            <BarChart
              datasets={emissionVehicleType?.[0]?.dataSet}
              labels={emissionVehicleType?.[0]?.labels}
              yAxisTitle={"GHG Emissions (tCO2e)"}
              customWidth={"90%"}
              display={true}
            />
          </div>
          <Box sx={{ width: "70%", mr: 4, ml: 2, mt: -4 }}>
            <p className={styles.card_subheading}>
              <CircleIcon sx={{ fontSize: "6px", mr: 1 }} />
              Emissions by vehicles (tCO2e)
            </p>
            {vehicleEmissionData?.length > 0 ? (
              <div>
                <div className={styles.total_combusstion_pie}>
                  <PieChart
                    labels={["Company Owned", "Third Party Vehicles"]}
                    dataset={vehicleEmissionData}
                    customWidth={150}
                    customHeight={150}
                    color={["#FF4444", "#0066E7"]}
                    hide={true}
                  />
                </div>
                <div className={styles.table_div_onroad}>
                  {vehicleEmission.map((item, index) => (
                    <div key={index} className={styles.table_container}>
                      <div className={styles.table_row}>
                        <span
                          className={styles.table_row_label}
                          style={{
                            backgroundColor: item.color,
                          }}
                        ></span>
                        <span className={styles.table_text}>{item.label}</span>
                      </div>
                      <span className={styles.table_text}>
                        {formatNumberCommaSeparated(fixedTons(item.value ?? 0))}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <Box sx={{ height: "80%" }}>
                <Typography
                  sx={{
                    textAlign: "center",
                    color: "#d3d3d3",
                    fontWeight: "bold",
                    alignItems: "center",
                    my: "8rem",
                    fontSize: "24px",
                    fontFamily: "inter",
                  }}
                >
                  No Data Found
                </Typography>
              </Box>
            )}
            {/* </div> */}
          </Box>
        </div>
      </div>

      {/* Off-Road: */}
      <div className={styles.cards}>
        <p className={styles.card_heading}>
          <CircleIcon sx={{ fontSize: "8px", mr: 1 }} />
          Off-Road:
        </p>
        <div className={styles.mobile_container}>
          {mobileEmissionOffRoad?.map((machinery, i) => (
            <div
              className={styles.diversity_container}
              style={{
                borderRight:
                  machinery?.title === "Industrial Machinery" &&
                  "2px solid rgba(218, 218, 218, 1)",
                borderRadius: 0,
              }}
            >
              <Box sx={{ width: "100%", mr: 0, ml: -2, mt: -1 }}>
                <p
                  className={styles.card_subheading}
                  style={{ marginRight: "-20px" }}
                >
                  <CircleIcon sx={{ fontSize: "6px", mr: 1 }} />
                  Emissions from {machinery?.title} (tCO2e) :
                  <span className={styles.emission_heading_span}>
                    {" "}
                    {formatNumberCommaSeparated(fixedTons(machinery?.value))}
                  </span>
                </p>
                {machinery?.data?.length > 0 ? (
                  <div className={styles.stationary_chart_container}>
                    <div className={styles.doughnut_table_div}>
                      {machinery?.data?.map((item, index) => (
                        <div key={index} className={styles.table_container}>
                          <div className={styles.table_row}>
                            <span
                              className={styles.table_row_label}
                              style={{
                                backgroundColor: item.color,
                              }}
                            ></span>
                            <span className={styles.table_text}>
                              {item.label}
                            </span>
                          </div>
                          <span className={styles.table_text}>
                            {formatNumberCommaSeparated(
                              fixedTons(item.value ?? 0)
                            )}
                          </span>
                        </div>
                      ))}
                    </div>
                    <Box sx={{ width: "60%", mt: 2 }}>
                      <EchartDoughnutChart
                        labels={machinery?.data?.map((el) => el?.label)}
                        dataPoints={machinery?.data?.map((el) =>
                          fixedTons(el?.value)
                        )}
                        colors={machinery?.data?.map((el) => el?.color)}
                        legendPosition="top"
                        customWidth={"100%"}
                        customHeight={"100%"}
                        hide={true}
                      />
                    </Box>
                  </div>
                ) : (
                  <Box sx={{ height: "40%" }}>
                    <Typography
                      sx={{
                        textAlign: "center",
                        color: "#d3d3d3",
                        fontWeight: "bold",
                        alignItems: "center",
                        my: "8rem",
                        fontFamily: "inter",
                        fontSize: "24px",
                      }}
                    >
                      No Data Found
                    </Typography>
                  </Box>
                )}
              </Box>
            </div>
          ))}
        </div>
      </div>

      {/* Fugitive Emission ANalysis */}
      <p className={styles.card_heading}>Fugitive Emission Analysis</p>
      <div className={styles.mobile_container}>
        {fugitive?.map((el) => (
          <div className={styles.diversity_container}>
            <p className={styles.emission_heading}>
              {el?.title}
              <span className={styles.emission_heading_span}>
                {formatNumberCommaSeparated(fixedTons(el?.value ?? 0))}
              </span>
            </p>
            <BarChart
              datasets={el?.dataSet}
              labels={el?.labels}
              yAxisTitle={"Quantity"}
              customWidth={420}
              customHeight={"375px"}
              ellipsis={true}
            />
          </div>
        ))}
      </div>

      <p className={styles.card_heading}>
        Comparative and Benchmarking Analysis
      </p>
      {comustionDataset?.map((el, idx) => (
        <div key={idx} className={styles.comparative_container}>
          <div className={styles.cards}>
            <p className={styles.emission_heading}>
              {el?.comustionHeading}
              <span className={styles.emission_heading_span}>
                Top 3 facilities
              </span>
            </p>

            <LineChart
              dataset={el?.dataset}
              labels={el?.labels}
              yAxisTitle={"GHG Emissions (tCO2e)"}
              customWidth="100%" // Optional custom width
              customHeight="300px" // Optional custom height
              display={true}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Dashboard;
